import { useCallback } from 'react';
import { CoreBox, CoreText } from '@vitvio/design-system';
import type { SurgerySlot } from '../types';
import { useJobCard } from '../hooks/useJobCard';
import { useConfirmPatientModal } from '../context/ConfirmPatientModalContext';
import { InfoBox } from './infoBox';

export function SurgeryCard(props: SurgerySlot) {
  const { data } = props;
  const { openConfirmModal } = useConfirmPatientModal();

  const { shadingHeight, statusColor, shadingColors } = useJobCard(data);

  const displayStart = data.actualStartTime ?? data.estimatedStartTime ?? data.plannedStart;
  const displayStop = data.actualStopTime ?? data.estimatedStopTime ?? data.plannedStop;
  const hasDelay =
    data.scheduleStatus === 'DELAYED' ||
    (data.durations?.delayAfterMinutes != null && data.durations.delayAfterMinutes > 0);

  const handleSurgeryClick = useCallback(() => {
    openConfirmModal({ ...data, displayStart, displayStop, hasDelay }, data.id);
  }, [openConfirmModal, data, displayStart, displayStop, hasDelay]);

  return (
    <CoreBox fullH bg={statusColor} borderRadius="md" flexColumn onClick={handleSurgeryClick} relative group>
      <CoreBox
        absolute
        bottom={0}
        fullW
        h={shadingHeight}
        borderRadiusB="md"
        bg={shadingColors?.bg}
        bgStripeColor={shadingColors?.stripe}
      />
      <CoreBox sticky top="0">
        <CoreBox p="2">
          <CoreBox flexRow fullW>
            <CoreText font="headings.XXS_SemiBold">{data?.procedureName}</CoreText>
          </CoreBox>
          {data.surgeonName && <CoreText font="S_Regular">{data.surgeonName}</CoreText>}
        </CoreBox>
        <InfoBox data={data} />
      </CoreBox>
    </CoreBox>
  );
}
